import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

import MessageBanner from "components/MessageBanner";
import FormInput from "core/FormInput";

import { SectionDark } from "core/Layout";
import { easingSeconds } from "core/animation";
import { A, P, BorderBottomLinkStyle } from "core/Typography";
import { regular } from "core/fontStyles";
import fonts from "core/fonts";
import breakpoints from "core/breakpoints";
import colors from "core/colors";

import NounLogoWordmark from "core/ReusableIcons/NounLogoWordmark";
import Button from "core/Button";

import { convertPxToRem } from "frontend/components/helpers";

// newsletter subscription
export const NewsletterSubscriptionSuccessMessage = styled(MessageBanner)`
    width: 20.125rem;

    @media (max-width: ${breakpoints.tablet.rem}) {
        width: 100%;
    }
`;

export const NewsletterSubscriptionSubmitBtn = styled(Button).attrs({
    darkMode: true,
    size: "md",
    width: convertPxToRem({ px: 95 }),
})`
    @media (max-width: ${breakpoints.tablet.rem}) {
        width: 100%;
    }
`;

export const NewsletterSubscriptionForm = styled.form`
    display: flex;

    ${FormInput} {
        margin-right: 0.8125rem;

        /* todo: update this breakpoint when we refactor footer */
        @media (max-width: ${breakpoints.tablet.rem}) {
            width: 100%;
        }

        @media (max-width: ${breakpoints.tablet.rem}) {
            margin-right: 0;
        }
    }

    @media (max-width: ${breakpoints.tablet.rem}) {
        display: block;
    }
`;

export const NewsletterSubscriptionHeading = styled(P)`
    ${regular}
    font-size: 1.125rem;
    color: ${colors.primary.diamond};
`;

export const NewsletterSubscription = styled.div`
    @media (max-width: ${breakpoints.tablet.rem}) {
        width: 100%;
        margin-top: 3rem;
        margin-bottom: 3rem;
    }

    ${NewsletterSubscriptionHeading} {
        margin-top: 0;
        margin-bottom: 1.25rem;
    }
`;

// logo
export const HomeLink = styled(A)`
    font-size: 13px;
    line-height: 16.5px;
`;

export const NounProjectLogo = styled(NounLogoWordmark)`
    width: 16.5rem;
    transition: opacity ${easingSeconds};

    &:hover {
        opacity: 0.6;
    }
`;

// text links
export const Link = styled(RouterLink)`
    text-decoration: none;
    ${BorderBottomLinkStyle}
    border-bottom: 1px solid ${colors.secondary.cosmic};
    &,
    &:any-link {
        color: ${colors.primary.diamond};

        &:hover {
            text-decoration: none;
            color: ${fonts.fontColors.light.link};
            border-color: ${fonts.fontColors.light.link};
        }
    }
`;

// copyright bar
export const CopyrightBar = styled(SectionDark)`
    ${regular}
    text-align: center;
    width: 100vw;
    padding: 0.5rem 0 0.75rem;
    color: ${colors.primary.diamond};
`;

// layout
export const SiteFooterGrid = styled.div`
    width: 100%;
    max-width: 82.375rem;
    margin: 0 auto;
    overflow-x: visible;
    padding-left: 0;
    padding-right: 0;
`;

export const FooterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
`;

export const FooterCol = styled.div`
    width: 100%;

    @media (min-width: ${breakpoints.tablet.rem}) {
        width: 50%;
    }

    @media (min-width: ${breakpoints.desktop.rem}) {
        width: 25%;
    }
`;

export const SiteFooterWrapper = styled(SectionDark)`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: ${colors.secondary.cosmic};
    padding-top: 5rem;
    padding-bottom: 5rem;

    @media (max-width: ${breakpoints.desktop.rem}) {
        padding-top: 3.625rem;
        padding-bottom: 3.625rem;
    }

    @media (max-width: ${breakpoints.tablet.rem}) {
        padding-top: 3.125rem;
        padding-bottom: 3.125rem;
    }

    /* desktop-only - restrict height due to extra 20px from newsletter forminput: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        height: ${convertPxToRem({ px: 240 })};
    }
`;

export const Footer = styled.footer`
    p {
        line-height: 16.5px;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    ${SiteFooterWrapper},
    ${CopyrightBar} {
        width: 100%;
        left: auto;
        right: auto;
        margin-left: 0;
        margin-right: 0;
    }
`;
